import { KeyboardEvent, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import moment from "moment";

import { DatePickerContext } from "./DatePickerContext";
import { DatePickerInputProps } from "./datePicker.type";

import Box from "../Box/Box";
import Input from "../Input/Input";

const DatePickerInputWrapper = styled(Box)`
  position: relative;
`;

const DatePickerInputStyled = styled(Input)`
  padding-right: 46px;
`;

const DatePickerInput = ({
  label,
  placeholder,
  value,
  dateFormat,
  onChange,
}: DatePickerInputProps) => {
  const {
    selectedDay,
    showCalendar,
    setShowCalendar,
    setSelectedDate,
    resetSelectedDate,
  } = useContext(DatePickerContext);

  const [inputValue, setInputValue] = useState<string>("");
  const [focused, setFocused] = useState<boolean>(showCalendar);

  const handleInputChange = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Delete" || e.key === "Backspace") {
      resetSelectedDate();
      onChange("");
    }
  };

  useEffect(() => {
    if (value && moment(value).isValid()) {
      setSelectedDate(value);
    } else {
      resetSelectedDate();
    }
  }, [value]);

  useEffect(() => {
    const selectedDate = selectedDay
      ? moment(selectedDay).format(dateFormat)
      : "";
    setInputValue(selectedDate);
  }, [selectedDay, dateFormat]);

  useEffect(() => {
    setFocused(showCalendar);
  }, [showCalendar]);

  return (
    <DatePickerInputWrapper aria-label="datepicker input">
      <DatePickerInputStyled
        label={label}
        icon="calendar-alt"
        iconWeight="regular"
        value={inputValue}
        onKeyDown={handleInputChange}
        onChange={() => {}}
        placeholder={placeholder}
        onFocus={() => setShowCalendar(true)}
        focused={focused}
      />
    </DatePickerInputWrapper>
  );
};

export default DatePickerInput;
